import { createFileRoute } from "@tanstack/react-router";
import { ContactHeroSection } from "@/components/marketing/sections/contact-hero-section";
import { ContactFormSection } from "@/components/marketing/sections/contact-form-section";

export const Route = createFileRoute("/_marketing/contact")({
  component: Contact,
});

function Contact() {
  return (
    <>
      <ContactHeroSection />
      <ContactFormSection />
    </>
  );
}
